
// From https://vanillajstoolkit.com/helpers/animate/
export const animateHelper = function (elem, animation, hide) {

	// If there's no element or animation, do nothing
	if (!elem || !animation) return

	// Remove the [hidden] attribute
	elem.classList.remove('hide')

	// Apply the animation
	elem.classList.add(animation)

	// Detect when the animation ends
	elem.addEventListener('animationend', function endAnimation (event) {

		// Remove the animation class
		elem.classList.remove(animation)

		// If the element should be hidden, hide it
		if (hide) {
			elem.setAttribute('hidden', 'true')
		}

		// Remove this event listener
		elem.removeEventListener('animationend', endAnimation, false)

	}, false)

}



// https://gist.github.com/christopher4lis/f9ccb589ee8ecf751481f05a8e59b1dc
/**
 * Rotates coordinate system for velocities
 *
 * Takes velocities and alters them as if the coordinate system they're on was rotated
 *
 * @param  Object | velocity | The velocity of an individual particle
 * @param  Float  | angle    | The angle of collision between two objects in radians
 * @return Object | The altered x and y velocities after the coordinate system has been rotated
 */

function rotate(velocity, angle) {
    const rotatedVelocities = {
        x: velocity.x * Math.cos(angle) - velocity.y * Math.sin(angle),
        y: velocity.x * Math.sin(angle) + velocity.y * Math.cos(angle)
    };

    return rotatedVelocities;
}



/**
 * Swaps out two colliding particles' x and y velocities after running through
 * an elastic collision reaction equation
 *
 * @param  Object | particle      | A particle object with x and y coordinates, plus velocity
 * @param  Object | otherParticle | A particle object with x and y coordinates, plus velocity
 * @return Null | Does not return a value
 */

// resolve collision with:
export function bounceOff(particle, otherParticle) {

	// params 
	particle.mass = 1
	otherParticle.mass = 1
    const xVelocityDiff = particle.velocity.x - otherParticle.velocity.x;
    const yVelocityDiff = particle.velocity.y - otherParticle.velocity.y;

    const xDist = otherParticle.x - particle.x;
    const yDist = otherParticle.y - particle.y;

    // Prevent accidental overlap of particles
    if (xVelocityDiff * xDist + yVelocityDiff * yDist >= 0) {

        // Grab angle between the two colliding particles
        const angle = -Math.atan2(otherParticle.y - particle.y, otherParticle.x - particle.x);

        // Store mass in var for better readability in collision equation
        const m1 = particle.mass;
        const m2 = otherParticle.mass;

        // Velocity before equation
        const u1 = rotate(particle.velocity, angle);
        const u2 = rotate(otherParticle.velocity, angle);

        // Velocity after 1d collision equation
        const v1 = { x: u1.x * (m1 - m2) / (m1 + m2) + u2.x * 2 * m2 / (m1 + m2), y: u1.y };
        const v2 = { x: u2.x * (m1 - m2) / (m1 + m2) + u1.x * 2 * m2 / (m1 + m2), y: u2.y };

        // Final velocity after rotating axis back to original location
        const vFinal1 = rotate(v1, -angle);
        const vFinal2 = rotate(v2, -angle);

        // Swap particle velocities for realistic bounce effect
        particle.velocity.x = vFinal1.x;
        particle.velocity.y = vFinal1.y;

        otherParticle.velocity.x = vFinal2.x;
        otherParticle.velocity.y = vFinal2.y;
    }
}



// RECTANGLE COLLISIONS
export function detectCollision(particle, otherParticle) {
	if (particle.x < otherParticle.x + otherParticle.width &&	// 
	   	particle.x + particle.width > otherParticle.x &&
	   	particle.y < otherParticle.y + otherParticle.height &&
	   	particle.y + particle.height > otherParticle.y) {
	    // collision detected!
		return true
	}
}



const getRandomInteger = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
}

const getRandomDecimal = (min, max) => {
    const num = (Math.random() * (max - min) + min).toFixed(2)
    return parseFloat(num)
}


function randomColor(colors) {
    return colors[Math.floor(Math.random() * colors.length)]
}

function distance(x1, y1, x2, y2) {
    const xDist = x2 - x1
    const yDist = y2 - y1

    return Math.sqrt(Math.pow(xDist, 2) + Math.pow(yDist, 2))
}